module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('price-status', {
    attrs: {
      "module": _vm.module
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5f30762","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/reprocessFeedPrice/filters/marketplace/Carrefour.vue
// module id = 3465
// module chunks = 0